import { MSG } from "constants/msg";
import { toast } from "sonner";
import { ApiResponseData } from "types/common";

const TOAST_CONFIG = { duration: 5000 };

export const info = (title: string, description?: string) => {
  toast.info(title, { ...TOAST_CONFIG, description });
}

export const success = (data: ApiResponseData) => {
  toast.success(data.data?.msg, TOAST_CONFIG);
};

export const error = (error: ApiResponseData) => {
  if (error.response?.status === 401) {
    window.location.href = "/logout";
  }

  toast.error(error.response?.data?.message ?? MSG.ERRORS.DEFAULT, TOAST_CONFIG);
};

export const successError = (data: ApiResponseData) => {
  if (data.data?.result == "success") {
    toast.success(data.data?.msg, TOAST_CONFIG);
  } else {
    toast.error(data.data?.msg, TOAST_CONFIG);
  }
};
